import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import { Card, CardBody } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Icon } from "@mc/mc-legacy";
import MenuItem from "./MenuItem";
import MenuPanel from "./MenuPanel";
import "./CardMenu.scss";
/**
 * Card menu.
 */

class CardMenu extends React.Component {
  static propTypes = {
    name: PropTypes.string,
    title: PropTypes.string.isRequired,
    icon: PropTypes.object,
    color: PropTypes.string.isRequired,
    items: PropTypes.array.isRequired,
  };
  isActive = (item) => {
    const { location } = this.props;
    return location.pathname.startsWith(item.path);
  };

  render() {
    const { items, title, icon, color } = this.props;
    return (
      <Card className="card-menu">
        <div
          className="menu-border"
          style={{
            background: color,
          }}
        ></div>
        <CardBody className="menu-header">
          {icon && (
            <div className="icon">
              <FontAwesomeIcon
                icon={icon}
                style={{
                  color: color,
                }}
              />
            </div>
          )}
          <h2 className="title">{title}</h2>
        </CardBody>
        <CardBody className="menu-content">
          <MenuPanel>
            {items.map((item, index) => (
              <MenuItem
                key={index}
                active={this.isActive(item)}
                name={item.title}
                route={item.path}
                count={{
                  number: item.count,
                  color: color,
                }}
              />
            ))}
          </MenuPanel>
        </CardBody>
      </Card>
    );
  }
}

export default withRouter(CardMenu);
